import React, { Component } from 'react'
import confirmImg from '../../../assets/images/newui/sellersignup/confirmation.svg'
import { loginSeller } from '../../../services/auth';
import './Confirmation.less'
import { setAuthState } from '../../../store/actions/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { pageView } from '../../../common/analytics'

class Confirmation extends Component {

    componentDidMount() {
        try
        {
            pageView('/confirmation', 'confirmation');
            const { email, password } = this.props;         
            loginSeller(email, password ).then((res) => {
                if (!res.error) {
                    setTimeout(() => {
                        this.props.setAuthState(true, res.data, '');
                        this.props.history.push({
                            pathname: '/complete-profile',
                            state: { oldPassword: password }
                        });
                    }, 2000)
                }
            });
        }catch(error)
        {
            console.log(error);
        }
        // login(email, password).then(response => {
        //     if (response.resStatus == 200) {
        //         validateSellerAuthorization().then((validRes) => {
        //             if (validRes.resStatus == 200) {
        //                 setTimeout(() => {
        //                     this.props.setAuthState(true, validRes.data.user, '');
        //                     this.props.history.push({
        //                         pathname: '/complete-profile',
        //                         state: { oldPassword: password }
        //                     });
        //                 }, 2000)
        //             }
        //         });
        //     }
        // })

        
        // login(email, password).then(response => {
        //     debugger
        //     if (response.resStatus == 200) {
        //         setTimeout(() => {
        //             this.props.setAuthState(true, response.data.user, '');
        //             this.props.history.push({
        //                 pathname: '/complete-profile',
        //                 state: { oldPassword: password }
        //             });
        //         }, 2000)
        //     }
        // })
    }

    render() {
        return <div className='confirmation-container'>
            <img src={confirmImg} />
            <div className='confirmation-user'>
                Thank you {this.props.user}
            </div>
            <div className='confirmation-separator' />
            <div className='order-header'>More Customers for your business are on the way.</div>
        </div>
    }
}


export default withRouter(connect(null, (dispatch) => { return bindActionCreators({ setAuthState }, dispatch) })(Confirmation));